<template lang="pug">
  item-block(:item="item", :active="active", @change:value="handleChange")
    template(v-slot="{ textStyle, handleChangeValue }")
      a-textarea(
        :active="active",
        :style="textStyle",
        :value="item.value",
        :class="$style.textarea",
        @change="handleChangeValue",
        @focus="isFocus = true",
        @blur="isFocus = false"
        spellcheck="false"
        :data-visible="isFocus"
      )
      div(ref="svg", :class="$style.svg", :data-visible="!isFocus")
      //- svg(:viewBox="`0 0 ${item.width * 100} ${item.height * 100}`")
      //-   text(font-family="Arial" x="0" y="0" font-size="30" fill="blue" text-anchor="middle") {{item.value}}
</template>
<script>
import ItemBlock from '@/components/Project/Edit/ItemBlock.vue'
import ItemBlockController from '@/utils/ItemBlockController'
import SvgTextArea from '@/utils/SvgTextArea'

export default {
  props: {
    active: { type: Boolean, default: true },
    item: { type: Object },
  },
  components: {
    ItemBlock,
  },
  data() {
    return {
      isFocus: false,
      svgText: null,
    }
  },
  computed: {
    svgOptions() {
      const itemBlock = new ItemBlockController(this.item)
      const { width, height } = itemBlock.convertBrowserSize()
      const anchor = (() => {
        switch (this.item.align) {
          case 'left':
            return 'start'
          case 'center':
            return 'middle'
          case 'right':
            return 'end'
          default:
            return ''
        }
      })()
      return {
        width: width - (this.item.padding_left + this.item.padding_right),
        height: height - (this.item.padding_top + this.item.padding_bottom),
        fontSize: this.item.font_size,
        color: this.item.color,
        strokeColor: this.item.stroke_color,
        strokeWidth: this.item.stroke_width,
        anchor,
      }
    },
  },
  methods: {
    handleChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    item() {
      this.svgText.options = {
        ...this.svgText.options,
        ...this.svgOptions,
      }
      this.svgText.text = this.item.value
      this.svgText.clear()
      this.svgText.generate()
    },
  },
  mounted() {
    this.svgText = new SvgTextArea(this.item.value, this.svgOptions, this.$refs.svg)
  },
}
</script>
<style module>
  textarea.textarea,
  textarea.textareaStroke {
    word-break: break-all;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    border-radius: 0;
    resize: none;
    padding: 0;
    cursor: pointer;
    opacity: 0;
    overflow: hidden;
    transition: none;
    &:focus {
      border: none;
      box-shadow: none;
    }
    &[data-visible="true"] {
      opacity: 1;
    }
    @nest [active] & {
      cursor: text;
    }
  }
  .svg {
    width: 100%;
    height: 100%;
    transform: translateY(-100%);
    pointer-events: none;
    opacity: 0;
    &[data-visible="true"] {
      opacity: 1;
    }
  }
</style>
